import { render, staticRenderFns } from "./CartFreeGiftProgress.vue?vue&type=template&id=8038b8c8&"
import script from "./CartFreeGiftProgress.vue?vue&type=script&lang=ts&"
export * from "./CartFreeGiftProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports